import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  useUpdate,
  useNotify,
  useRecordContext,
  useGetList,
  FunctionField,
  Create,
  Edit,
  SimpleForm,
  TextInput,
  required,
} from 'react-admin';

// ==========================
// Create
// ==========================
export const PaymentChannelCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <ReferenceInput source="method" reference="payment-methods" label="Method">
        <SelectInput optionText="name" validate={required()} />
      </ReferenceInput>

      <TextInput source="channel_name" label="Channel name" validate={required()} />
      <TextInput source="phone_number" label="Phone number" validate={required()} />

      <ReferenceInput source="agent" reference="agents" label="Agent (দায়িত্বপ্রাপ্ত)">
        <SelectInput optionText="display_name" />
      </ReferenceInput>
    </SimpleForm>
  </Create>
);

// ==========================
// Edit — এখানে agent dropdown ঠিকভাবে কাজ করবে (ফর্ম কনটেক্সট আছে)
// ==========================
export const PaymentChannelEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <ReferenceInput source="method" reference="payment-methods" label="Method">
        <SelectInput optionText="name" validate={required()} />
      </ReferenceInput>

      <TextInput source="channel_name" label="Channel name" validate={required()} />
      <TextInput source="phone_number" label="Phone number" validate={required()} />

      <ReferenceInput source="agent" reference="agents" label="দায়িত্বপ্রাপ্ত এজেন্ট">
        <SelectInput optionText="display_name" emptyText="- Select an option -" />
      </ReferenceInput>
    </SimpleForm>
  </Edit>
);

// ==========================
// List (ইনলাইন এজেন্ট সিলেক্ট সহ — plain <select>, ফর্ম-ফ্রি)
// ==========================
const InlineAgentSelect = () => {
  const record = useRecordContext();
  const [update, { isLoading: isUpdating }] = useUpdate();
  const notify = useNotify();
  const { data: agents, isLoading } = useGetList('agents', {
    pagination: { page: 1, perPage: 200 },
    sort: { field: 'display_name', order: 'ASC' },
  });

  if (!record) return null;

  const handleChange = (event) => {
    const value = event.target.value;
    const agentId = value === '' ? null : value;
    update(
      'payment-channels',
      { id: record.id, data: { agent: agentId }, previousData: record },
      {
        onSuccess: () => notify('এজেন্ট আপডেট হয়েছে', { type: 'success' }),
        onError: () => notify('আপডেট ব্যর্থ হয়েছে', { type: 'error' }),
      }
    );
  };

  return (
    <select
      value={record.agent ?? ''}
      onChange={handleChange}
      disabled={isLoading || isUpdating}
      onClick={(e) => e.stopPropagation()}
      style={{
        padding: '4px 8px',
        background: '#1e1e2f',
        color: '#fff',
        border: '1px solid #444',
        borderRadius: 4,
      }}
    >
      <option value="">- Select an option -</option>
      {agents &&
        agents.map((agent) => (
          <option key={agent.id} value={agent.id}>
            {agent.display_name}
          </option>
        ))}
    </select>
  );
};

// === পরিবর্তন: এখন ব্যাকএন্ড থেকে আসা is_locked ফিল্ড অনুযায়ী স্ট্যাটাস দেখাবে ===
const StatusField = () => {
  const record = useRecordContext();
  if (!record) return null;

  if (!record.agent) {
    return <span style={{ color: 'gray' }}>— এজেন্ট নেই</span>;
  }

  if (record.is_locked) {
    return <span style={{ color: '#e74c3c' }}>🔒 লকড</span>;
  }

  return <span style={{ color: 'limegreen' }}>🟢 চালু আছে</span>;
};

export const PaymentChannelList = (props) => (
  <List {...props}>
    <Datagrid rowClick="edit" bulkActionButtons={false}>
      <TextField source="channel_name" label="Channel name" />
      <ReferenceField source="method" reference="payment-methods" label="Method">
        <TextField source="name" />
      </ReferenceField>
      <TextField source="phone_number" label="Phone number" />
      <FunctionField label="দায়িত্বপ্রাপ্ত এজেন্ট" render={() => <InlineAgentSelect />} />
      <FunctionField label="স্ট্যাটাস" render={() => <StatusField />} />
    </Datagrid>
  </List>
);